<template>
<div class="page time-schedule">
  <h1>Uurrooster</h1>
</div>
</template>

<script>
export default {
name: "TimeSchedule"
}
</script>

